// Generated by scripts/fetch-laws.ts from lawsofux.com and timsommer.be. Do not edit directly.
import type { Law } from "../types";
import { aestheticUsabilityEffect } from "./aesthetic-usability-effect";
import { choiceOverload } from "./choice-overload";
import { chunking } from "./chunking";
import { cognitiveBias } from "./cognitive-bias";
import { cognitiveLoad } from "./cognitive-load";
import { dohertyThreshold } from "./doherty-threshold";
import { fittssLaw } from "./fittss-law";
import { flow } from "./flow";
import { goalGradientEffect } from "./goal-gradient-effect";
import { hicksLaw } from "./hicks-law";
import { jakobsLaw } from "./jakobs-law";
import { lawOfCommonRegion } from "./law-of-common-region";
import { lawOfProximity } from "./law-of-proximity";
import { lawOfPraegnanz } from "./law-of-praegnanz";
import { lawOfSimilarity } from "./law-of-similarity";
import { lawOfUniformConnectedness } from "./law-of-uniform-connectedness";
import { mentalModel } from "./mental-model";
import { millersLaw } from "./millers-law";
import { occamsRazor } from "./occams-razor";
import { paradoxOfTheActiveUser } from "./paradox-of-the-active-user";
import { paretoPrinciple } from "./pareto-principle";
import { parkinsonsLaw } from "./parkinsons-law";
import { peakEndRule } from "./peak-end-rule";
import { postelsLaw } from "./postels-law";
import { selectiveAttention } from "./selective-attention";
import { serialPositionEffect } from "./serial-position-effect";
import { teslersLaw } from "./teslers-law";
import { vonRestorffEffect } from "./von-restorff-effect";
import { workingMemory } from "./working-memory";
import { zeigarnikEffect } from "./zeigarnik-effect";
import { murphysLaw } from "./murphys-law";
import { brooksLaw } from "./brooks-law";
import { hofstadtersLaw } from "./hofstadters-law";
import { conwaysLaw } from "./conways-law";
import { peterPrinciple } from "./peter-principle";
import { kerchkhoffsPrinciple } from "./kerchkhoffs-principle";
import { linussLaw } from "./linuss-law";
import { mooresLaw } from "./moores-law";
import { wirthsLaw } from "./wirths-law";
import { ninetyNinetyRule } from "./ninety-ninety-rule";
import { knuthsOptimizationPrinciple } from "./knuths-optimization-principle";
import { norvigsLaw } from "./norvigs-law";

/** All laws: the 30 laws of UX in lawsofux.com homepage order, then the laws of software development. */
export const laws: Law[] = [
  aestheticUsabilityEffect,
  choiceOverload,
  chunking,
  cognitiveBias,
  cognitiveLoad,
  dohertyThreshold,
  fittssLaw,
  flow,
  goalGradientEffect,
  hicksLaw,
  jakobsLaw,
  lawOfCommonRegion,
  lawOfProximity,
  lawOfPraegnanz,
  lawOfSimilarity,
  lawOfUniformConnectedness,
  mentalModel,
  millersLaw,
  occamsRazor,
  paradoxOfTheActiveUser,
  paretoPrinciple,
  parkinsonsLaw,
  peakEndRule,
  postelsLaw,
  selectiveAttention,
  serialPositionEffect,
  teslersLaw,
  vonRestorffEffect,
  workingMemory,
  zeigarnikEffect,
  murphysLaw,
  brooksLaw,
  hofstadtersLaw,
  conwaysLaw,
  peterPrinciple,
  kerchkhoffsPrinciple,
  linussLaw,
  mooresLaw,
  wirthsLaw,
  ninetyNinetyRule,
  knuthsOptimizationPrinciple,
  norvigsLaw,
];

/** Laws keyed by their stable ASCII slug. */
export const lawBySlug: Readonly<Record<string, Law>> = Object.fromEntries(
  laws.map((law) => [law.slug, law]),
);
